/**
 * シーズンのルックブック：51 件目以降のルックを読み込んで追加する
 *
 * リスト型メタフィールドは 1 回の描画で 50 件までしか出せないため、
 * セクションが data-next-url（メタフィールド専用のページ引数付き URL）を出している間、
 * Section Rendering API で次のページを取得してギャラリーの末尾に追加する。
 */
(() => {
  const loadRemainingLooks = async (gallery) => {
    const sectionId = gallery.dataset.sectionId;
    let nextUrl = gallery.dataset.nextUrl;
    const seen = new Set();

    while (nextUrl && !seen.has(nextUrl)) {
      seen.add(nextUrl);
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      let nextGallery;
      try {
        const response = await fetch(url.toString());
        if (!response.ok) break;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        nextGallery = html.querySelector('[data-tata-lookbook-gallery]');
      } catch {
        break;
      }
      if (!nextGallery) break;

      const fragment = document.createDocumentFragment();
      nextGallery.querySelectorAll(':scope > .tata-season-lookbook__look').forEach((look) => {
        fragment.appendChild(document.importNode(look, true));
      });
      gallery.appendChild(fragment);

      nextUrl = nextGallery.dataset.nextUrl;
    }

    delete gallery.dataset.nextUrl;
  };

  const init = () => {
    document.querySelectorAll('[data-tata-lookbook-gallery][data-next-url]').forEach((gallery) => {
      loadRemainingLooks(gallery);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
